import { messstelle, kenngroesse } from './../../../utils/apiTypes';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { colNameType, messstellePqIndex, pqIndexResult, pqIndexResultForMessstelle } from "./pqIndexTypes";
import { postJsonWithAuth } from "../../../utils/api";
import { logError, convertDateToWeekNumber } from "../../../utils/utils";
import { errorHandler } from '../../../utils/errorHandling';

const initialState: messstellePqIndex
  = {
  messstelleKenngroesse: [],
  messstelleZeit: [],
  loadingMessstellenKenngroesse: false,
  loadingMessstellenZeit: false,
}

const messstellePqIndexSlice = createSlice({
  name: "messstellePqIndex",
  initialState,
  reducers:
  {
    setMessstelleKenngroesse: (state, action: PayloadAction<{
      uwName: string,
      kategorieName: string;
      liste_headerArray: Array<colNameType>;
      liste_horizentalArray: Array<number>;
      liste_vertikalArray: Array<number>;
      min_allNumber: number;
      pqIndexArray: Array<Array<pqIndexResult>>;
      isOld: boolean
    }>) => {
      const value: pqIndexResultForMessstelle = {
        uw: action.payload.uwName,
        kategorie: action.payload.kategorieName,
        liste_header: action.payload.liste_headerArray,
        liste_horizental: action.payload.liste_horizentalArray,
        liste_vertikal: action.payload.liste_vertikalArray,
        min_all: action.payload.min_allNumber,
        pqIndex: action.payload.pqIndexArray,
        isOld: action.payload.isOld
      }

      state.messstelleKenngroesse.push(value);
    },

    setMessstelleZeit: (state, action: PayloadAction<{
      uwName: string,
      kategorieName: string;
      liste_headerArray: Array<colNameType>;
      liste_horizentalArray: Array<number>;
      liste_vertikalArray: Array<number>;
      min_allNumber: number;
      pqIndexArray: Array<Array<pqIndexResult>>;
      isOld: boolean
    }>) => {
      const value: pqIndexResultForMessstelle = {
        uw: action.payload.uwName,
        kategorie: action.payload.kategorieName,
        liste_header: action.payload.liste_headerArray,
        liste_horizental: action.payload.liste_horizentalArray,
        liste_vertikal: action.payload.liste_vertikalArray,
        min_all: action.payload.min_allNumber,
        pqIndex: action.payload.pqIndexArray,
        isOld: action.payload.isOld
      };
      state.messstelleZeit.push(value);
    },
    setLoadingMessstellenKenngroesse: (state, action: PayloadAction<boolean>) => {
      state.loadingMessstellenKenngroesse = action.payload;
    },
    setLoadingMessstellenZeit: (state, action: PayloadAction<boolean>) => {
      state.loadingMessstellenZeit = action.payload;
    },
    deleteTabForMessstelleZeit: (state, action: PayloadAction<string>) => {
      for (let index = 0; index < state.messstelleZeit.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        const element = state.messstelleZeit[index];
        if (element.uw == action.payload) {
          state.messstelleZeit.splice(index, 1)
        }
      }
    },
    deleteTabForMessstelleKenngroesse: (state, action: PayloadAction<string>) => {
      for (let index = 0; index < state.messstelleKenngroesse.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        const element = state.messstelleKenngroesse[index];
        if (element.uw == action.payload) {
          state.messstelleKenngroesse.splice(index, 1)
        }
      }
    },
    setOldTabMessstelle: (state) => {
      for (let index = 0; index < state.messstelleKenngroesse.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        state.messstelleKenngroesse[index].isOld = true;
      }
      for (let index = 0; index < state.messstelleZeit.length; index++) {
        // eslint-disable-next-line security/detect-object-injection
        state.messstelleZeit[index].isOld = true;
      }
    },
  }
});
export const selectMessstelleZeit = (state: RootState): pqIndexResultForMessstelle[] => state.messstellePqIndex.messstelleZeit;
export const selectMessstelleKenngroesse = (state: RootState): pqIndexResultForMessstelle[] => state.messstellePqIndex.messstelleKenngroesse;
export const selectLoadingMessstellenKenngroesse = (state: RootState): boolean => state.messstellePqIndex.loadingMessstellenKenngroesse;
export const selectLoadingMessstellenZeit = (state: RootState): boolean => state.messstellePqIndex.loadingMessstellenZeit;

export const getMessstelleKenngroesse =
  (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean, groupByKenngroessenkategorieParam: boolean, uwName: string) => (
    dispatch: AppDispatch): void => {

    const body = {
      start: startParam,
      end: endeParam,
      kenngroessen: kenngroesseParam,
      messstellen: messstelleParam,
      pqIndexMin: pqIndexMinParam,
      pqIndexMax: pqIndexMaxParam,
      grenzwertsatzName: grenzwertsatz
    }

    dispatch(setLoadingMessstellenKenngroesse(true))
    postJsonWithAuth("PQINDEXMESSSTELLEKENNGROESSE", { groupByUw: grupByUWParam, groupByKenngroessenkategorie: groupByKenngroessenkategorieParam }, body)
      .then((response: Array<Array<pqIndexResult>>) => {

        const kenngroesseList: Array<colNameType> = [];
        const tempMinHorizentalList: Array<number> = [];
        const tempMinVertikalList: Array<number> = [];
        let tempMinMessstellenAll = 10;
        let tempMinKenngroesseAll = 10;

        response.forEach(rows => {
          let tempMin = rows[0].value === null || rows[0].value === undefined ? 10 : rows[0].value;
          rows.forEach(row => {
            kenngroesseList.push({ name: row.col, col: row.col })
            if (row.value !== null && row.value !== undefined) {
              if (tempMin > row.value) {
                tempMin = row.value
              }
            }
          })
          tempMinVertikalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinMessstellenAll > tempMin) {
              tempMinMessstellenAll = tempMin;
            }
          }
        })

        kenngroesseList.sort((a, b) => a.name.localeCompare(b.name))
        const filterdKenngroesseList: Array<colNameType> = kenngroesseList.filter(function (elem, pos, self) {
          return self.findIndex((x) => (
            x.name === elem.name && x.col === elem.col
          )) == pos
        })

        filterdKenngroesseList.forEach(kenngroesseElem => {
          const initData = response[0][0];
          let tempMin = 11;
          if (kenngroesseElem.col == initData.col) {
            tempMin = initData.value;
          }
          response.forEach(rows => {
            rows.forEach(row => {
              if (kenngroesseElem.col == row.col) {
                if (row.value !== null && row.value !== undefined) {
                  if (tempMin > row.value) {
                    tempMin = row.value
                  }
                }
              }
            })
          })
          tempMinHorizentalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinKenngroesseAll > tempMin) {
              tempMinKenngroesseAll = tempMin;
            }
          }
        })
        dispatch(setMessstelleKenngroesse({
          uwName: uwName,
          kategorieName: "kenngroesse",
          liste_headerArray: filterdKenngroesseList,
          liste_horizentalArray: tempMinHorizentalList,
          liste_vertikalArray: tempMinVertikalList,
          min_allNumber: tempMinMessstellenAll < tempMinKenngroesseAll ? tempMinMessstellenAll : tempMinKenngroesseAll,
          pqIndexArray: response,
          isOld: false
        }));

      })
      .catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
      }).finally(() => dispatch(setLoadingMessstellenKenngroesse(false)));
  };

export const getMessstelleZeit =
  (messstelleParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, pqIndexMinParam: number, pqIndexMaxParam: number, grenzwertsatz: string, grupByUWParam: boolean, groupByKenngroessenkategorieParam: boolean, uwName: string) => (
    dispatch: AppDispatch): void => {

    const body = {
      start: startParam,
      end: endeParam,
      kenngroessen: kenngroesseParam,
      messstellen: messstelleParam,
      pqIndexMin: pqIndexMinParam,
      pqIndexMax: pqIndexMaxParam,
      grenzwertsatzName: grenzwertsatz
    }

    dispatch(setLoadingMessstellenZeit(true))
    postJsonWithAuth("PQINDEXMESSSTELLEZEIT", { groupByUw: grupByUWParam, groupByKenngroessenkategorie: groupByKenngroessenkategorieParam }, body)
      .then((response: Array<Array<pqIndexResult>>) => {

        const kwList: Array<colNameType> = [];
        const tempMinHorizentalList: Array<number> = [];
        const tempMinVertikalList: Array<number> = [];
        let tempMinMessstellenAll = 10;
        let tempMinZeitAll = 10;

        response.forEach(rows => {
          let tempMin = rows[0].value === null || rows[0].value === undefined ? 10 : rows[0].value;
          rows.forEach(row => {
            const dateTemp: Date = new Date(row.col);
            const convertWeekNumber = convertDateToWeekNumber(dateTemp);
            const yearOfWeekNumber = dateTemp.getFullYear();
            const colElem: colNameType = { name: convertWeekNumber.toString().length > 1 ? "KW " + "(" + yearOfWeekNumber + ") " + convertWeekNumber : "KW " + "(" + yearOfWeekNumber + ") " + "0" + convertWeekNumber, col: row.col }
            kwList.push(colElem)
            if (row.value !== null && row.value !== undefined) {
              if (tempMin > row.value) {
                tempMin = row.value
              }
            }
          })
          tempMinVertikalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinMessstellenAll > tempMin) {
              tempMinMessstellenAll = tempMin;
            }
          }
        })

        kwList.sort((a, b) => a.name.localeCompare(b.name))
        const filterdKwList: Array<colNameType> = kwList.filter(function (elem, pos, self) {
          return self.findIndex((x) => (
            x.name === elem.name && x.col === elem.col
          )) == pos
        })

        filterdKwList.forEach(zeitElem => {
          const initData = response[0][0];
          let tempMin = 11;
          const dateTempInit = initData.col;
          if (zeitElem.col == dateTempInit) {
            tempMin = initData.value;
          }
          response.forEach(rows => {
            rows.forEach(row => {
              const dateTempCol = row.col;
              if (zeitElem.col == dateTempCol) {
                if (row.value !== null && row.value !== undefined) {
                  if (tempMin > row.value) {
                    tempMin = row.value
                  }
                }
              }
            })
          })
          tempMinHorizentalList.push(tempMin)
          if (tempMin !== null && tempMin !== undefined) {
            if (tempMinZeitAll > tempMin) {
              tempMinZeitAll = tempMin;
            }
          }
        })

        dispatch(setMessstelleZeit({
          uwName: uwName,
          kategorieName: "zeit",
          liste_headerArray: filterdKwList,
          liste_horizentalArray: tempMinHorizentalList,
          liste_vertikalArray: tempMinVertikalList,
          min_allNumber: tempMinMessstellenAll < tempMinZeitAll ? tempMinMessstellenAll : tempMinZeitAll,
          pqIndexArray: response,
          isOld: false
        }));

      })
      .catch((error) => {
        logError(error);
        errorHandler(error, dispatch);
      }).finally(() => dispatch(setLoadingMessstellenZeit(false)));
  };

export const {
  setMessstelleKenngroesse,
  setMessstelleZeit,
  setLoadingMessstellenKenngroesse,
  setLoadingMessstellenZeit,
  deleteTabForMessstelleZeit,
  deleteTabForMessstelleKenngroesse,
  setOldTabMessstelle
} = messstellePqIndexSlice.actions;

export default messstellePqIndexSlice.reducer;